import React, { useState, useRef, useCallback, useEffect } from "react";
import { useStyles } from "src/pages/ServiceOrdersDetails/tabs/Summary/EditSOSummary/styles";
import { AxiosResponse } from "axios";
import { Typography, Button, Grid, CircularProgress, TextField } from "@material-ui/core";
import { requestPut } from "src/utils/crud";
import { useAppContext } from "src/providers/AppProvider";
import { useTranslation } from "react-i18next";
import Modal from "src/components/Modal";
import SuccessNotification from "src/pages/ServiceOrdersDetails/tabs/Summary/EditSOSummary/SuccessNotification";
import { useSODetailsContext } from "src/providers/SODetailsStore";

const EditSpecialInstructions: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation("orders");
  const [loading, setLoading] = useState<boolean>(false);
  const submitButtonRef = useRef<HTMLButtonElement>(null);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const {
    state: {
      modals: { editSpecialInstrctionsSO },
    },
    callAppAPI: { toggleModal },
  } = useAppContext();

  const {
    serviceOrderDetails: { serviceOrder },
    callAPI: { setContextData },
  } = useSODetailsContext();

  const [specialInstruction, setSpecialInstruction] = useState(serviceOrder.specialInstruction);

  const handleModalClose = useCallback(() => {
    toggleModal({ id: "editSpecialInstrctionsSO", status: false });
    setSubmitted(false);
  }, []);

  const handleChange = (event: React.ChangeEvent<any>) => {
    setSpecialInstruction(event.target.value);
  };

  const submitSI = async (data: any) => {
    try {
      const res = await requestPut(`ServiceOrders/${serviceOrder.id}/specialInstruction`, data);
      return res;
    } catch (err) {
      return console.log(err);
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    submitButtonRef.current?.setAttribute("disabled", "disabled");
    const submitObj = { specialInstruction: specialInstruction };
    const instructionsRes = await submitSI(submitObj);

    if ((instructionsRes as AxiosResponse).status === 200) {
      setSubmitted(true);
      const newServiceOrder = {
        ...serviceOrder,
        specialInstruction: specialInstruction,
      };
      setContextData("serviceOrder", newServiceOrder);
    }
    setLoading(false);
    submitButtonRef.current?.removeAttribute("disabled");
  };

  useEffect(() => {
    serviceOrder && setSpecialInstruction(serviceOrder.specialInstruction);
  }, [serviceOrder]);

  return (
    <>
      <Modal isOpen={editSpecialInstrctionsSO} onClose={handleModalClose}>
        <Grid container justify="center" style={{ width: "100%" }}>
          <Grid item style={{ width: "100%" }}>
            {!submitted && (
              <form onSubmit={handleSubmit}>
                <Typography variant="h3">{t("labels.details.edit_instructions")}</Typography>
                <div className={classes.fieldGroup}>
                  <TextField
                    fullWidth
                    label={t("labels.details.Special_instructions")}
                    placeholder={t("labels.details.Special_instructions")}
                    rows={4}
                    multiline
                    name="notes"
                    value={specialInstruction}
                    onChange={handleChange}
                    variant="outlined"
                    inputProps={{ maxLength: 500 }}
                  />
                </div>
                <div className={classes.btnGroup}>
                  <Button className={classes.submitBtn} type="submit" ref={submitButtonRef}>
                    {loading ? (
                      <CircularProgress size={18} color={"secondary"} />
                    ) : (
                      t("labels.common.save")
                    )}
                  </Button>
                  <Button onClick={handleModalClose} className={classes.cancelBtn}>
                    {t("labels.common.cancel")}
                  </Button>
                </div>
              </form>
            )}
            {submitted && (
              <SuccessNotification
                message={t("labels.common.save_success")}
                onClose={handleModalClose}
              />
            )}
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default EditSpecialInstructions;
